<template>
  <v-card
    flat
    class="pa-3 mt-1"
  >
    <v-card-title class="d-flex align-center justify-center py-0">
      <v-img
        :src="require(`@/assets/images/logos/logo.png`)"
        max-width="300px"
        alt="logo"
        contain
        class="me-0"
      ></v-img>
    </v-card-title>

```
<v-form class="multi-col-validation">
  <v-card-text class="pt-1">
    <p class="text-h6 text-center">Add an Advertisment {{ resourceKey }} Resource</p>
    <v-row>
      <!-- Nouveau sélecteur de section -->
      <v-col cols="12" class="py-0 my-1">
        <v-select
          v-model="selectedSection"
          :items="sections"
          label="Select Section"
          outlined
          dense
          required
        ></v-select>
      </v-col>

      <v-col cols="12" class="py-0 my-1">
        <v-text-field
          v-model="resourceName"
          ref="resource_name"
          outlined 
          dense
          label="Enter Resource Name"
        ></v-text-field>
      </v-col>

      <v-col cols="12" class="py-0 my-1">
        <v-textarea
          v-model="resourceDescription"
          ref="resource_description"
          outlined
          label="Enter Resource Description"
        ></v-textarea>
      </v-col>

      <v-col cols="12" class="py-0 my-1">
        <v-file-input
          v-model="resourceFile"
          show-size
          truncate-length="18"
          label="Choose Resource File"
          outlined
        ></v-file-input>
      </v-col>
    </v-row>
  </v-card-text>

  <v-card-text class="text-end">
    <spinner v-if="loading" />
    <v-btn 
      v-else
      color="primary"
      class="me-3 mt-3"
      @click="addResource"
    >
      Add {{ resourceKey }}
    </v-btn>
  </v-card-text>
</v-form>
```

  </v-card>
</template>

<script>
import axios from 'axios'
import Spinner from "@/components/Spinner.vue";

export default {
  components: { Spinner },
  
  data() {
    return {
      loading: false,
      resourceName: "",
      resourceDescription: "",
      resourceFile: null,
      selectedSection: null,
      sections: [
        'Savings',
        'Market Place',
        'Njangi',
        'Crowd Funding',
        'Monitor',
        'Business Suite' // Nouvelle option ajoutée
      ]
    }
  },

  computed: {
    resourceKey() {
      return this.$route.params.key
    }
  },

  mounted() {
    document.title = `Manager: Savings | Add ${this.resourceKey} Resource`
  },

  methods: {
    async addResource() {
      if (!this.validateForm()) return
      
      this.loading = true
      
      try {
        const formData = new FormData()
        formData.append('resourceName', this.resourceName)
        formData.append('resourceDescription', this.resourceDescription)
        formData.append('resourceFile', this.resourceFile)
        formData.append('section', this.selectedSection)

        const response = await axios.post(
          '/api/v1/manager/businessadd/marketing_resource/', 
          formData
        )

        this.handleSuccess(response)
      } catch (error) {
        this.handleError(error)
      } finally {
        this.loading = false
      }
    },

    validateForm() {
      if (!this.selectedSection) {
        this.showError("Please select a section", 'selectedSection')
        return false
      }
      if (!this.resourceName) {
        this.showError("Please fill in the resource name", 'resource_name')
        return false
      }
      if (!this.resourceDescription) {
        this.showError("Please input the resource description", 'resource_description')
        return false
      }
      if (!this.resourceFile) {
        this.showError("Please upload the resource file", 'resource_file')
        return false
      }
      return true
    },

    showError(message, refName) {
      this.$store.commit('setSnackBarMessage', message)
      this.$store.commit('setSnackBarColor', "red darken-4")
      this.$store.commit('activateSnackBar', true)
      if (refName) this.$refs[refName].focus()
    },

    handleSuccess(response) {
      this.$store.commit('setSnackBarMessage', "Video added successfully")
      this.$store.commit('setSnackBarColor', "success")
      this.$store.commit('activateSnackBar', true)
      
      // Redirection conditionnelle selon la section
      if (this.selectedSection === 'Business Suite') {
        this.$router.push('/savings/Business/videos')
      } else {
        this.$router.push('/savings/Business/videos')
      }
    },

    handleError(error) {
      const message = error.response?.data?.detail || "An error occurred while adding the video"
      this.showError(message)
    }
  }
}
</script>
